export const blockIconsNavigationMoreVert = (
	<span className='material-symbols-outlined'>more_vert</span>
);
